import { Amplify } from 'aws-amplify';
import { getAppConfig, isAppConfigured } from './config';

/** Cognito is the only auth mode when env is complete. */
export function isCognitoMode(): boolean {
  return isAppConfigured();
}

export function configureAmplify(): void {
  if (!isAppConfigured()) return;
  const { userPoolId, clientId, region } = getAppConfig();
  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId,
        userPoolClientId: clientId,
        loginWith: { email: true },
      },
    },
  });
  void region;
}
